import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-chip',
    templateUrl: './chip.component.html',
    styleUrl: './chip.component.scss',
    standalone: true,
    imports: [
        CommonModule,
        MatIconModule, MatTooltipModule
    ]
})
export class ChipComponent {

    @Input() hasAction: boolean = true
    @Input() filledStyle: boolean = false
    @Input() iconName: string | null = null
    @Input() hasClose: boolean = true
    @Input() iconClass: string = "material-icons-outlined"
    @Input() toolTipDelay: number = 400
    @Input() customIcon: boolean = false
    @Input() allwaysLabel: boolean = false
    @Input() label: string = ""
    @Input() isSelect: boolean = false
    @Input() selected: boolean = false
    @Input() disabled: boolean = false;
    @Input() isDatePicker: boolean = false
    @Input() opened: boolean = false
    @Input() maxTextLength: number = 20
    @Input() selectedMaxWidth: string = '650px'

    @Input()
    set text(p: string | null | undefined | string[]) {
        this.firstText = p
        this.createText(p)
    }

    @Output() action: EventEmitter<boolean> = new EventEmitter()
    @Output() close: EventEmitter<boolean> = new EventEmitter()

    firstText: string | null | undefined | string[] = null
    aText: string = "empty"
    toolTip: string = ""

    constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer) { }

    ngOnInit(): void {
        this.createText(this.firstText)
        if (this.customIcon && this.iconName != null) {
            this.matIconRegistry.addSvgIcon(
                this.iconName,
                this.domSanitizer.bypassSecurityTrustResourceUrl("assets/" + this.iconName + ".svg")
            );
        }
    }

    createText(currentText: string | null | undefined | string[]): void {

        if (currentText != undefined && currentText && Array.isArray(currentText) && currentText[0] != undefined && currentText[0] != null && currentText[0] != "") {
            if (currentText.length > 1) {
                this.toolTip = currentText.join(" / ")
                if (this.maxTextLength > 0) {
                    this.aText = currentText[0].substring(0, this.maxTextLength) + " +" + (currentText.length - 1)
                    return
                }
                this.aText = currentText[0] + " +" + (currentText.length - 1)
                return
            }
            this.toolTip = currentText[0]

            if (this.maxTextLength > 0) {

                if (currentText[0] == undefined) {
                    return
                }

                this.aText = currentText[0].substring(0, this.maxTextLength)
                return
            }

            this.aText = currentText[0]
            return
        }

        if (typeof currentText === "string" && currentText != null && currentText != "") {

            this.toolTip = currentText
            if (this.maxTextLength > 0) {
                this.aText = currentText.substring(0, this.maxTextLength)
                return
            }

            this.aText = currentText
            return
        }

        this.toolTip = this.label
        this.aText = this.label
    }

    emitAction(state: boolean) {
        if (this.disabled == true) {
            return;
        }

        this.action.emit(state);
    }

}
